module.exports = __webpack_public_path__ + "img/ve.46affed8.svg";